<script>
  // import mapStyles from "./map-styles"; // optional
  import { onMount } from "svelte";
  export let center;
  export let zoom = 8;
  export let polylines = [];
  export let markers = [];
  export let busMarkers = [];
  let container;
  let map;
  let busStops = [];
  let busses = [];

  onMount(async () => {
    map = new google.maps.Map(container, {
      zoom,
      center
      // styles: mapStyles // optional
    });

    polylines.forEach(polyline => {
      polyline.path = google.maps.geometry.encoding.decodePath(polyline.path);
      let mapPolyline = new google.maps.Polyline(polyline);
      mapPolyline.setMap(map);
    });

    markers.forEach(marker => {
      let mapMarker = new google.maps.Marker({
        position: marker.position,
        map: map,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: "white",
          fillOpacity: 1,
          scale: 5,
          strokeColor: "grey",
          strokeWeight: 2,
          zIndex: 10
        },
        title: marker.title
        // label: marker.title
      });
      let infoWindow = new google.maps.InfoWindow({
        content: marker.title
      });
      mapMarker.addListener("click", function() {
        infoWindow.open(map, mapMarker);
      });
    });
  });

  $: {
    for (let x = 0; x < busMarkers.length; x++) {
      if (busses[x] !== undefined) busses[x].setMap(null);
      busses[x] = new google.maps.Marker({
        position: busMarkers[x].position,
        map: map,
        icon: {
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          rotation: busMarkers[x].heading,
          fillColor: "black",
          fillOpacity: 1,
          scale: 6,
          strokeColor: "white",
          strokeWeight: 2,
          zIndex: 99999
        },
        title: busMarkers[x].title
      });
    }
  }
</script>

<style>
  .full-screen {
    width: 100vw;
    height: 85vh;
  }
</style>

<div class="full-screen" bind:this={container} />
